import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router';

import {
  AlertModule,
  FooterModule,
  HeaderModule,
  LoaderModule,
  LogoModule,
  MainContentModule,
  NavbarModule,
  ScrollbarModule,
  SidebarModule
} from '@michelin/theme';
import { LogoutModule } from 'src/app/features/authentication/components/logout/logout-module';
import { CamSpecificationModule } from 'src/app/features/cam-specification/cam-specification.module';
import { SearchCamSpecModule } from 'src/app/features/search-cam-spec/search-cam-spec.module';
import { LanguageDropdownModule } from 'src/app/shared/translations/language-dropdown/language-dropdown-module';
import { LayoutComponent } from './base-layout/layout.component';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { CustomerModule } from 'src/app/features/customer/customer.module';
import { NotificationBellComponent } from 'src/app/shared/components/notification-bell.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SidebarModule,
    AlertModule,
    NavbarModule,
    LogoModule,
    ScrollbarModule,
    LanguageDropdownModule,
    LogoutModule,
    SearchCamSpecModule,
    CamSpecificationModule,
    MatCardModule,
    SidebarModule,
    MainContentModule,
    FooterModule,
    HeaderModule,
    LoaderModule,
    CustomerModule,
    NotificationBellComponent
  ],
  providers: [],
  declarations: [LayoutComponent, MainLayoutComponent]
})
export class LayoutModule {}
